import type { BubbleChartService } from "../services/bubble.service"
import { bubbleTransform } from "../adpaters/transformers/bubble.transform"

export enum BubbleChartType {
    DEFI_VS_TRADFI_TVL = "bubble-defi-vs-tradfi-tvl",
    STABLECOIN_VS_BANKS = "bubble-stablecoin-vs-banks",
    // Add more bubble chart types here
}

export interface BubbleChartConfig {
    id: string
    dataLoader: () => Promise<any>
    transformer: (data: any) => any
    options?: {
        colors?: string[]
        minRadius?: number
        maxRadius?: number
        forceStrength?: number
        collisionStrength?: number
    }
}

export const createBubbleChartConfigs = (bubbleChartService: BubbleChartService) => {
    return new Map<string, BubbleChartConfig>([
        [BubbleChartType.DEFI_VS_TRADFI_TVL, {
            id: BubbleChartType.DEFI_VS_TRADFI_TVL,
            dataLoader: () => bubbleChartService.loadBubbleDefiTradfiTVL(),
            transformer: bubbleTransform.defiTradfiTVLtoBubbleDO,
            options: {
                colors: ['#2C3280', '#3742E2'],
                minRadius: 0.1,
                maxRadius: 0.2,
                forceStrength: 0.04,
                collisionStrength: 0.03
            }
        }],
        [BubbleChartType.STABLECOIN_VS_BANKS, {
            id: BubbleChartType.STABLECOIN_VS_BANKS,
            dataLoader: () => bubbleChartService.loadStablecoinVsBanks(),
            transformer: bubbleTransform.stablecoinVsBanksToBubbleDO,
            options: {
                colors: ['#2C3280', '#3742E2'],
                minRadius: 0.08,
                maxRadius: 0.25,
                forceStrength: 0.06,
                collisionStrength: 0.05
            }
        }]
    ]);
}

// Legacy support - keeping the old interface for backward compatibility
export const bubbleTypesOptions = new Map<string, Function>([
    [BubbleChartType.DEFI_VS_TRADFI_TVL, bubbleTransform.defiTradfiTVLtoBubbleDO]
])

